import React from "react";
import {Box} from "@mui/material";

export interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

const TabPanel = (props: TabPanelProps) => {
    const {children, value: tabValue, index, ...other} = props;

    return (
        <div
            role="tabpanel"
            hidden={tabValue !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {tabValue === index && <Box sx={{p: 3}}>{children}</Box>}
        </div>
    );
};

export default TabPanel;
